interface ValidationErrorProps {
  message?: string | null;
  className?: string;
}

export function ValidationError({
  message,
  className = 'text-xs text-ybh-error mt-1',
}: ValidationErrorProps): JSX.Element | null {
  if (!message) return null;
  return <p className={className}>{message}</p>;
}
